import { useMemo } from 'react'
import { usePageConfig } from '@hooks/usePageConfig'
import { FormattedMessage, useIntl } from 'react-intl'
import { useAppDispatch, useAppSelector } from 'universal-scripts'
import { selectDataItem } from 'src/store/slices/dataExplorer'
import SearchData from '@components/SearchData/SearchData'
import DataExplorer from '@components/DataExplorer/DataExplorer'
import DataSetInfo from './DataSetInfo/DataSetInfo'
import ExternalHeaderContent from '@components/ExternalHeaderContent/ExternalHeaderContent'
import type { DataItemPayload } from 'src/types/global'

import './DataSets.css'

export default function DataSets() {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const selectedItem = useAppSelector(
    (state) => state.dataExplorer.selectedItem
  )

  const handleSelect = (item: DataItemPayload) => dispatch(selectDataItem(item))
  const handleClear = () => dispatch(selectDataItem(undefined))

  const headerContent = useMemo(() => {
    const crumbs = [
      {
        label: intl.formatMessage({ id: 'nav.data-sets' }),
        path: '/data-sets'
      }
    ]
    return <ExternalHeaderContent hasBack crumbs={crumbs} />
  }, [intl])

  usePageConfig('data-sets', headerContent)

  return (
    <section className="split main-content">
      <div className="item item-left">
        <h1>
          <FormattedMessage id="home-content.explore.title" />
        </h1>
        <SearchData onSelect={handleSelect} />
        <DataExplorer selectedId={selectedItem?.id} onSelect={handleSelect} />
      </div>
      <div className="item item-right">
        <DataSetInfo selectedItem={selectedItem} onClear={handleClear} />
      </div>
    </section>
  )
}
